<template>
  <div class="spl-edit-template__step spl-book-references">
    <div class="row">
      <div v-for="(reference, index) in bookingData.additional_references_list" :key="index">
        <div
          v-show="bookingData.book_parcel_model.References[index].Visible"
          v-if="index % 2 === 0 && reference.Reference_Type_ID !== constants.REFERENCE_TYPE_ID.COUNTER_NUMBER"
          class="col5">
          <form-label>{{ reference.Reference_Type_Name }}</form-label>
          <form-input
            v-model="bookingData.book_parcel_model.References[index].Reference_Text"
            :class="'reference-' + reference.Reference_Type_ID"
            :enable-trim="true" />
        </div>
        <div
          v-show="bookingData.book_parcel_model.References[index].Visible"
          v-if="index % 2 !== 0 && reference.Reference_Type_ID !== constants.REFERENCE_TYPE_ID.COUNTER_NUMBER"
          class="col5">
          <form-label>{{ reference.Reference_Type_Name }}</form-label>
          <form-input
            v-model="bookingData.book_parcel_model.References[index].Reference_Text"
            :class="'reference-' + reference.Reference_Type_ID"
            :enable-trim="true" />
        </div>
      </div>
    </div>

    <!-- Next step footer -->
    <general-footer
      :cancel-visible="$mq === 'sm'"
      :disable-positive="false"
      :positive-label="nextStepLabel"
      negative-label="Back"
      @negativeClicked="previousStep"
      @positiveClicked="nextStep" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import constants from '@/constants'
export default {
  name: 'BookingAdditionalReferences',
  props: ['bookingData', 'nextStepLabel'],
  data () {
    return {
      nextClicked: false,
      constants,
      profileData: {}
    }
  },
  mounted () {
    this.$watch(vm => [vm.bookingData.book_parcel_model.Country_ID, vm.bookingData.book_parcel_model.Customer_ID, vm.bookingData.book_parcel_model.Is_Forward], val => {
      if (this.bookingData.book_parcel_model.Country_ID !== -1 && this.bookingData.book_parcel_model.Customer_ID !== -1) {
        this.getProfiler(this.bookingData.book_parcel_model.Customer_ID, this.bookingData.book_parcel_model.Country_ID, this.bookingData.book_parcel_model.Is_Forward)
      }
    },
    {
      immediate: true,
      deep: true
    })
  },
  methods: {
    ...mapActions('profiler', ['loadProfiler']),
    nextStep () {
      this.$emit('nextStep', this.bookingData)
      this.nextClicked = true
    },
    previousStep () {
      this.$emit('previousStep', this.bookingData)
    },
    reset () {
      this.nextClicked = false
      this.$forceUpdate()
    },
    getProfiler (customer_id, country_id, is_forward) {
      var profileFilter = { Customer_ID: customer_id, Country_ID: country_id, Is_Forward: is_forward }
      this.loadProfiler(profileFilter).then(() => {
        this.profileData = JSON.parse(window.sessionStorage.getItem('Profiler_List'))
        this.bookingData.book_parcel_model.References.forEach(reference => {
          if (this.profileData !== null && this.profileData.Fields.length > 0) {
            const found = this.profileData.Fields.find(el => el.Name.toLowerCase() === reference.Reference_Type_Name.toLowerCase())
            if (found) {
              reference.Visible = found.Visible
            } else {
              reference.Visible = true
            }
            if (found && this.$route.params.return_id) {
              if (found.CopyValues === false) {
                reference.Reference_Text = ''
              }
            }
          } else {
            reference.Visible = true
          }
        })
        this.$forceUpdate()
      }).catch((error) => {
        window.bus.$emit('openErrorModal', error.ExceptionMessage)
      })
    },
    isValid () {
      return this.nextClicked
    }
  }
}
</script>

<style lang="scss">
@import '../../variables.scss';
@include mobile() {
  .spl-book-references {
    & .spl-label {
      margin-top: 10px;
    }
  }
}
</style>
